import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import AccArrowUp from '../../../images/contract-admin-icons/AccArrowUp';
import AccArrowDown from '../../../images/contract-admin-icons/AccArrowDown';

const MidAccordion = ({
  mainContent,
  isDisable,
  innerChild,
  hasChild = false,
}) => {
  const inputRef = useRef(false);
  const [active, setActive] = useState(false);
  const handleToggle = () => {
    inputRef.current = !active;
    setActive(!active);
  };

  return (
    <Fragment>
      <div className="ent-mid-acc">
        {mainContent}
        {hasChild && (
          <button
            type="button"
            disabled={isDisable}
            ref={inputRef}
            key={Math.random()}
            className="ent-mid-acc-toggle"
            onClick={() => handleToggle()}
          >
            {active ? <AccArrowUp /> : <AccArrowDown />}
          </button>
        )}
      </div>
      {active && innerChild}
    </Fragment>
  );
};

MidAccordion.propTypes = {
  hasChild: PropTypes.bool,
  isDisable: PropTypes.bool,
  innerChild: PropTypes.element,
  mainContent: PropTypes.element,
};

export default React.memo(MidAccordion);
